import App from 'app/app.js';

function LtPromiseDirective() {
  return {
    restrict: 'E',
    template:
      '<div class="row">' +
      '    <div class="col-xs-12 guarantee">' +
      '       <img lt-translate-src="LIFETOUCH_PROMISE_IMAGE" alt="{{LIFETOUCH_PROMISE_ALT_TEXT | ltTranslateFilter}}" />' +
      '       <br/><span lt-translate="LIFETOUCH_PROMISE_TEXT"></span>' +
      '    </div>' +
      '</div>'
  };
}

App.directive('ltPromise', LtPromiseDirective);
